import useNotification from "utils/hooks/useNotification";
import Text from "common/Typography/Text";
import Link from "common/Typography/Link";
import Title from "common/Typography/Title";
import AntCloseCircleOutlined from "@ant-design/icons/CloseCircleOutlined";
import { useTheme } from "styled-components";
import styled from "styled-components";

const useFormattedNotification = () => {
  const appTheme = useTheme();
  const [notificationApi, contextHolder] = useNotification();

  const getFormattedDescription = (description: string) => {
    const arrayMessage = description.split("\n");
    return (
      <>
        {arrayMessage.map((line, index) => {
          if (URL_REGEX.test(line)) {
            const lineArray = line.split(RegExp(URL_REGEX));
            return (
              <div key={index} style={{ color: appTheme.colors.primaryText }}>
                {lineArray.map((text, index) => {
                  if (URL_REGEX.test(text)) {
                    const link = text.replace(STRIP_END_DOT_REGEX, "");
                    return (
                      <Link
                        key={index}
                        href={HTTP_REGEX.test(text) ? link : `https://${link}`}
                        target="_blank"
                      >
                        {text.replace(STRIP_URL_PREFIX_REGEX, "")}
                      </Link>
                    );
                  }
                  return text;
                })}
              </div>
            );
          }
          return <Text key={index}>{line}</Text>;
        })}
      </>
    );
  };

  const getTitle = (title: string) => {
    return (
      <NotificationTitle>
        <CloseCircleOutlined />
        <Title level={3}>{title}</Title>
      </NotificationTitle>
    );
  };

  const getErrorNotification = (description: string, title?: string) => {
    notificationApi.open({
      message: title ? getTitle(title) : undefined,
      description: getFormattedDescription(description),
      placement: "bottomLeft",
      duration: 0,
      style: { width: 400 },
    });
  };

  return { getErrorNotification, notificationApi, contextHolder };
};

export default useFormattedNotification;

const URL_REGEX = /(www[\w.ֿ\/\-_:?=]+|http[\w.ֿ\/\-_:?=]+)/g;
const HTTP_REGEX = /http[\w.ֿ\/\-_:?=]+/g;
const STRIP_END_DOT_REGEX = /\.+$/g;
const STRIP_URL_PREFIX_REGEX = /^(https|http):\/\/www\.|www\.+/g;

const NotificationTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;
const CloseCircleOutlined = styled(AntCloseCircleOutlined)`
  color: ${(p) => p.theme.colors.red};
  margin-right: 8px;
  font-size: ${(p) => p.theme.typography.fontSizes.XL};
`;
